export default "__VITE_ASSET__$HHvQhbS__"